// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 20.432c0-.313.254-.567.568-.567h15.567a.73.73 0 00.73-.73V3.568a.568.568 0 111.135 0v15.567A1.865 1.865 0 0119.135 21H3.568A.568.568 0 013 20.432z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;